/**
 * File Uploader
 * @param containerSelector
 */
window.fileUploader = function(containerSelector) {
  const allContainer = document.querySelectorAll(containerSelector);
  if (allContainer) {
    allContainer.forEach((container) => {
      const dropZone = container.querySelector('.drop-zone');
      const fileInput = dropZone.querySelector('.file-input');
      const fileList = container.querySelector('.file-list');

      // Listen for file input change event
      window.bubbleEvent(fileInput, 'change', (e) => {
        const files = e.target.files;
        handleFiles(files);
      });

      // Prevent default behavior on dragover event
      window.bubbleEvent(dropZone, 'dragover', (e) => {
        e.preventDefault();
        dropZone.setAttribute('style', 'border-color:#28a745;');
      });

      // Prevent default behavior on dragover event
      window.bubbleEvent(dropZone, 'dragleave', (e) => {
        e.preventDefault();
        dropZone.removeAttribute('style');
      });

      // Handle drop event
      window.bubbleEvent(dropZone, 'drop', (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        handleFiles(files);
      });

      // Trigger file input click when drop zone is clicked
      window.bubbleEvent(dropZone, 'click', () => {
        fileInput.click();
      });

      /**
       * Handles the selected files for upload.
       * @param {FileList} files - The list of selected files.
       */
      function handleFiles(files) {
        dropZone.removeAttribute('style');
        uploadFiles(files);
        fileInput.value = '';
      }

      /**
       * Uploads the selected files.
       * @param {FileList} files - The list of selected files.
       */
      function uploadFiles(files) {
        for (const file of files) {
          // Create a new list item element
          const listItem = document.createElement('div');
          listItem.className = 'file-list-item';

          // Populate the list item with file information
          listItem.innerHTML = '<div class="row align-items-center">' +
              '<div class="col-xs-11">' +
              '<span class="file-name">' + file.name + ' <small>(' + window.formatFileSize(file.size) + ')</small></span>' +
              '<input class="file-input-hidden" type="hidden" name="u[files][]" value="">' +
              '</div>' +
              '<div class="col-xs-1 tar"><i class="material-icons delete-btn vam hand">delete</i></div>' +
              '<div class="col-xs-12">' +
              '<div class="progress"><div class="progress-bar" role="progressbar" style="width:0;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">0%</div></div>' +
              '<div class="status-text"></div>' +
              '</div>' +
              '</div>';

          // Add the list item to the file list
          fileList.appendChild(listItem);

          // Initiate the file upload
          uploadFile(file, listItem);
        }
      }

      /**
       * Uploads a single file.
       * @param {File} file - The file to upload.
       * @param {HTMLElement} progressElement - The progress element for the file.
       */
      function uploadFile(file, progressElement) {
        const formData = new FormData();
        formData.append('file', file);
        if (container.getAttribute('data-event')) {
          formData.append('eventKey', container.getAttribute('data-event'));
        }
        if (container.getAttribute('data-type')) {
          formData.append('eventType', container.getAttribute('data-type'));
        }

        const progressBar = progressElement.querySelector('.progress-bar');
        const statusText = progressElement.querySelector('.status-text') || document.createElement('div');

        // max files
        if (fileList.querySelectorAll('.file-list-item').length > MAX_FILES) {
          statusText.textContent = 'Error: ' + LANG_STRINGS.UPLOAD_ERROR_MAXIMAL_ANZAHL_DATEIEN;
          statusText.classList.add('text-red');
          progressBar.style.width = `100%`;
          progressBar.classList.add('progress-bar-danger');
        } else {

          const xhr = new XMLHttpRequest();
          xhr.open('POST', BASE_PATH + 'ajax/helper/additional/fileUpload');

          // Update progress bar during upload
          xhr.upload.addEventListener('progress', (e) => {
            const percent = Math.round(e.lengthComputable ? (e.loaded / e.total) * 100 : 0);
            progressBar.style.width = `${percent}%`;
            progressBar.textContent = `${percent}%`;
          });

          // Handle upload completion
          xhr.onload = () => {
            if (xhr.status === 200) {
              const response = JSON.parse(xhr.responseText);
              if (response.success) {
                progressBar.textContent = `${response.message}`;
                progressBar.classList.add('progress-bar-success');

                progressElement.querySelector('span.file-name').innerHTML = '<a href="' + response.link + '" target="_blank">' + response.fileNameOriginal + '</a> <small>(' + window.formatFileSize(response.fileSize) + ')</small>';
                progressElement.querySelector('.file-input-hidden').value = response.fileNameMd5;
              } else {
                statusText.textContent = `Error: ${response.message}`;
                statusText.classList.add('text-red');
                progressBar.classList.add('progress-bar-danger');
              }
            } else {
              statusText.textContent = `Error: ${xhr.status}`;
              statusText.classList.add('text-red');
              progressBar.classList.add('progress-bar-danger');
            }
          };

          // Send the FormData
          xhr.send(formData);
        }
      }

      /**
       * Handles the deletion of a file.
       * @param {Event} e - The event object.
       */
      function handleDelete(e) {
        autoLoader();

        const deleteBtn = e.target;
        deleteBtn.setAttribute('onclick', 'return false;');
        const listItem = deleteBtn.closest('div.file-list-item');

        if (listItem) {
          if (typeof listItem.querySelector('input') !== 'undefined') {
            const fileID = listItem.querySelector('input');

            const xhr = new XMLHttpRequest();
            xhr.open('POST', BASE_PATH + 'ajax/helper/additional/fileDelete');

            const formData = new FormData();
            formData.append('fileKey', fileID.value);

            xhr.send(formData);

            xhr.onload = () => {
              autoLoader('body', true);
              fileList.removeChild(listItem);
            };
          }
        }
      }

      // Add event listener for delete button clicks
      window.bubbleEvent(fileList, 'click', (e) => {
        if (e.target.classList.contains('delete-btn')) {
          handleDelete(e);
        }
      });
    });
  }
};
